import type { Country } from './common';

/**
 * Implements:
 * https://www.nhs.uk/using-the-nhs/about-the-nhs/what-is-an-nhs-number/
 * https://en.wikipedia.org/wiki/NHS_number
 */
export class GB implements Country {
	private static readonly VALIDATION_REGEX = /^[0-9]{10}$/;

	public validate(input: string): boolean {
		// Strip all whitespace.
		const normalizedNumber = this.normalize(input);

		// Verify that the NHS number consists of exactly 10 ASCII digits.
		const isStructurallyValid = normalizedNumber.match(GB.VALIDATION_REGEX);
		if (!isStructurallyValid) {
			return false;
		}

		let checksum = 0;
		// Multiply each of the first 9 digits by 11 subtracted by their 1-based position (here, it is
		// 10 subtracted by their 0-based position for simplicity).
		for (let i = 0; i < 9; i++) {
			checksum += parseInt(normalizedNumber[i]) * (10 - i);
		}
		// Get the remainder of the checksum divided by 11, then subtract 11 by the remainder to get
		// the checksum total.  If the total is 11, it is considered to be 0 (done here by getting the
		// remainder of the total divided by 11).
		checksum = (11 - (checksum % 11)) % 11;

		// If the total is equal to the check digit, the NHS number is valid.
		return checksum === parseInt(normalizedNumber[9], 10);
	}

	public normalize(input: string): string {
		return input.replace(/ /g, '');
	}

	public getDateOfBirth(): null {
		return null;
	}
}
